export default "__VITE_ASSET__miZ64Qt$__"